<script>
export default {
	inheritAttrs: false,
}
</script>

<template>
	<DeliveryOptionContent v-on="$listeners" v-bind="$attrs" />
</template>
